import { Redirect, Route, Switch } from "react-router-dom";
import { SysInfoPage } from "pages/settings/SysInfoPage";

export const SysInfoRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/sys-info">
        <SysInfoPage />
      </Route>

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect to="/pages/sys-info" from="/pages/sys-info" />
      <Redirect to="/pages" />
    </Switch>
  );
};
